

export const downloadBlob = (blob: Blob, filename: string) => {
	const dataUrl = URL.createObjectURL(blob);
	try {
		chrome.downloads.download({
			url: dataUrl,
			filename,
			saveAs: true
		});
	} catch {
		const anchorElement = document.createElement('a');
		anchorElement.style.setProperty('display', 'none');
		anchorElement.setAttribute('href', dataUrl);
		anchorElement.setAttribute('download', filename);
		document.body.appendChild(anchorElement);
		anchorElement.click();
		document.body.removeChild(anchorElement);
	}
	setTimeout(() => {
		URL.revokeObjectURL(dataUrl);
	}, 10000);
};
